import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { Headline } from '../Headline/Headline';

import styles from './AutoCompletePopover.module.css';

export const LocationNotFound = ({ isLocationNotFound }: { isLocationNotFound?: boolean }) => {
  const { t } = useAppContext();

  if (!isLocationNotFound) return null;

  return (
    <div className={styles.popoverInfoContainer}>
      <Headline size="h6" as="h5" label={t('search.searchbar.filters.autosuggest.empty.header')} />
      <Copy size="m" text={t('search.searchbar.filters.autosuggest.empty.body')} />
    </div>
  );
};
